/**
 * Utility functions for handling image URLs in the admin panel
 */

import { API_BASE_URL } from './api';

/**
 * Returns the image URL unchanged.
 * The 10.0.2.2 → localhost rewrite was removed because it corrupts production
 * image URLs (10.0.2.2 is an Android emulator address that never appears in prod).
 *
 * @param {string} url - The image URL to process
 * @returns {string} - The URL as-is
 */
export const normalizeImageUrl = (url) => {
  if (!url) return url;
  return url;
};

/**
 * Resolves a provider image to a loadable URL.
 *
 * `provider.images` stores bare image NAMES (the entity column is `image_name`, and ProviderDto
 * passes them through verbatim) — rendering one directly resolves against the admin panel's own
 * origin and 404s. The backend serves them from `/images/{size}/{name}`, which SecurityConfig
 * marks permitAll, so a plain <img> works without an auth header.
 *
 * Legacy rows are tolerated: anything already absolute or root-relative is returned untouched.
 *
 * @param {string} name - stored image name, or a legacy absolute/root-relative URL
 * @param {'small'|'medium'|'large'} size - served resolution
 * @returns {string} - a loadable URL
 */
export const providerImageUrl = (name, size = 'medium') => {
  if (!name) return '';
  if (/^(https?:)?\/\//i.test(name) || name.startsWith('/')) return name;
  return `${API_BASE_URL}/images/${size}/${name}`;
};

export default {
  normalizeImageUrl,
  providerImageUrl,
};
